import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import Tooltip from 'components/Tooltip';
import { useIsMobileWithBreakpoint } from 'hooks/useIsMobileWithBreakpoint';
import { PVI_NO_STYLES_CLASSNAME } from 'utils/helpers/inclusion';
import styles from './styles.module.scss';

const RubricatorTag = ({
	ariaLabel,
	title,
	isButtonAll,
	onClick,
	hasMore = false,
	active = false
}) => {
	const isMobile = useIsMobileWithBreakpoint('tabletSmall');
	const maxCharacters = 30;
	const isTitleLongerThanMaxCharacters =
		maxCharacters && title.replaceAll(' ', '').length > maxCharacters;

	const tagCx = cx(styles.RubricatorTag, {
		[styles.RubricatorTag_active]: active,
		[styles.RubricatorTag_withTooltip]: isTitleLongerThanMaxCharacters
	});

	const tagContainerCx = cx(styles.RubricatorTag__Container, {
		[styles.RubricatorTag__Container_active]: active
	});

	return (
		<div className={tagContainerCx} data-active={active}>
			<button type="button" className={tagCx} onClick={onClick}>
				<span
					className={cx(styles.RubricatorTag__Title, {
						[styles.RubricatorTag__Title_overflow]: !!maxCharacters
					})}
					style={{ maxWidth: maxCharacters && `${maxCharacters}ch` }}
				>
					{!isButtonAll && (
						<span className={styles.RubricatorTag__ScreenreaderText}>
							Рубрика {title}
						</span>
					)}
					<span aria-hidden="true">{title}</span>
					{isButtonAll && (
						<span className={styles.RubricatorTag__ScreenreaderText}>
							{title} рубрики {ariaLabel}
						</span>
					)}
				</span>
				{hasMore ? (
					<Icon
						className={cx(styles.RubricatorTag__HasMoreIcon)}
						icon="small-arrow-cursor"
						aria-hidden="true"
					/>
				) : null}
			</button>
			{isTitleLongerThanMaxCharacters ? (
				<>
					<div
						className={styles.RubricatorTag__TooltipContainer}
						data-tooltip-id={title}
					>
						<Icon
							className={cx(
								styles.RubricatorTag__TooltipIcon,
								PVI_NO_STYLES_CLASSNAME
							)}
							icon="question-mark"
							useClassName={PVI_NO_STYLES_CLASSNAME}
							aria-hidden="true"
						/>
					</div>
					<Tooltip
						id={title}
						content={title}
						noArrow
						openOnClick={isMobile}
						closeOnScroll={isMobile}
						closeOnResize
					/>
				</>
			) : null}
		</div>
	);
};

RubricatorTag.propTypes = {
	ariaLabel: PropTypes.string,
	title: PropTypes.string.isRequired,
	isButtonAll: PropTypes.bool,
	active: PropTypes.bool,
	onClick: PropTypes.func,
	hasMore: PropTypes.bool
};

export default RubricatorTag;
